import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { m as c } from "motion/react";
import { useAnimateFadeIn as r } from "../../../animation/animation.js";
import { Heading as d } from "../../elements/heading/heading.js";
import i from "./usp-block.module.less.js";
const N = ({ title: n, uspList: a }) => {
  const t = r({ whileInView: !0, easing: "easeInOut" });
  return /* @__PURE__ */ e("section", { className: "space-mb-2xl", children: /* @__PURE__ */ m(c.div, { ...t, className: "max-width padded-sides centered", children: [
    /* @__PURE__ */ e(d, { semanticType: "h2", visualType: "h5", className: "heading-max-width", children: n }),
    a && /* @__PURE__ */ e("ul", { className: i.list, children: a.map((s, l) => /* @__PURE__ */ m("li", { className: i.item, children: [
      /* @__PURE__ */ e("span", { className: [i.icon, "ui-icon-check bold"].join(" ") }),
      /* @__PURE__ */ e("p", { className: "mb-0 body-base", children: s.title })
    ] }, s.title + "-" + l)) })
  ] }) });
};
export {
  N as USPBlock,
  N as default
};
